import { trpc } from "@blis/trpc/react";

import { ConfirmPrompt } from "@/components/ConfirmPrompt";
import { toast } from "@/components/ui/toast";
import { useDialogProps } from "../detail/state";

export function RestoreDialog({ accession }: { accession: { id: number } }) {
  const dialogProps = useDialogProps("restore");
  const restore = trpc.accession.restore.useMutation({
    onSuccess() {
      toast.success("Accession restored");
    },
    onError: (err) => {
      toast.error("Error restoring accession", {
        description: err.message,
      });
    },
  });

  const confirmClicked = async () => {
    await restore.mutateAsync({ id: accession.id });
    dialogProps.onOpenChange?.(false);
  };

  return (
    <ConfirmPrompt
      {...dialogProps}
      message={`Are you sure you want restore accession ${accession.id}?`}
      title="Confirm restore"
      onConfirm={confirmClicked}
      loading={restore.isPending}
    />
  );
}
